// extracted by mini-css-extract-plugin
export default {"block":"block__lI26IdcT","grid":"grid__sTBNn6VR"};